<template>
    <!-- snb -->
    <nav id="snb">
        <section class="snb_sec mypage_wrap" v-if="myPageList.length">
            <h2>{{ $t('TITLE.GLOBAL.MYPAGE') }}</h2>
            <div class="list">
                <ul class="list_mymenu">
                    <!-- myPage top 3 -->
                    <li v-for="menu in myPageList" :key="menu.menuId">
                        <a href="javascript:" @click="handleMoveMenu($event, menu)">{{ menu.menuNm }}</a>
                    </li>
                </ul>
            </div>
        </section>

        <section class="snb_sec mymenu_wrap" v-if="treeObj.length">
            <dl class="tree_wrap" style="border-top:0px solid #aaa">
                <h2>Admin</h2>
                <!-- search_tree 추가 -->
                <dd>
                    <article class="tree_group">
                        <!-- <p class="tree_subtitle">Category</p> -->
                        <ul class="tree_list">
                            <li v-for="menu1 in treeObj" :key="'tree' + menu1.menuId">
                                <a href="javascript:" class="ico_tree" v-if="menu1._children" @click="treeClick($event, menu1.menuId)">
                                    <span class="sr_only"></span>
                                </a>
                                <span @click="handleMoveMenu($event, menu1, menu1._children)">{{ menu1.menuNm }}</span>
                                <ul class="tree_sub_list" v-if="menu1._children">
                                    <li v-for="menu2 in menu1._children" :key="'tree' + menu2.menuId">
                                        <a href="javascript:" class="ico_tree" v-if="menu2._children" @click="treeClick($event, menu2.menuId)">
                                            <span class="sr_only"></span>
                                        </a>
                                        <span @click="handleMoveMenu($event, menu2, menu2._children)">{{ menu2.menuNm }}</span>
                                        <ul class="tree_sub_list" v-if="menu2._children">
                                            <li v-for="menu3 in menu2._children" :key="'tree' + menu3.menuId">
                                                <a href="javascript:" class="ico_tree" v-if="menu3._children" @click="treeClick($event, menu3.menuId)">
                                                    <span class="sr_only"></span>
                                                </a>
                                                <span @click="handleMoveMenu($event, menu3, menu3._children)">{{menu3.menuNm}}</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </article>
                </dd>
            </dl>
        </section>
    </nav>
    <!-- //snb -->
</template>

<script>
import Vue                                  from 'vue';
import { mapGetters }                       from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import axios                                from 'axios';
import qs                                   from 'query-string';
import store                                from '@/vuex/store';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import ToastTreeGrid                        from '~c/ToastTreeGrid';

export default {
    name: 'AdminSnb',
    data() {
        return {
            myPageList: [],
            treeObj: []
        };
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            myPages: 'getMyPages',
            params: 'getParams',
            loginSystem: 'getLoginSystem',
        }),
        getMyPageList() {
            return this.myPages['subMenu'] || [];
        },
    },
    components: {
        'tree-grid': ToastTreeGrid,
    },
    methods: {
        // 컴포넌트 생성시 동작
        initLoad() {
            this.myPageList = this.getMyPageList;
            const ADMIN_MENU = MenuUtil.getAdminMenu;
            const adminMenus = _.find(this.menus, function(m) {
                return ADMIN_MENU.includes(m.menuId);
            });

            // Notice, Image Cloud를 가장 앞으로 Start - 2020.07.20 김남갑
            const noticeMenu = '|LEFT_0000051681|LEFT_0000000003|LEFT_0000063679|LEFT_0000064679|LEFT_0000034867|LEFT_0000074859';
            let groupMenus = [], aloneMenus = [];
            adminMenus.subMenu.forEach(elm => {
                if (noticeMenu.indexOf(elm.menuId) < 0 && elm.menuId != 'LEFT_1000000004') groupMenus.push(elm); // Image Cloud
                else aloneMenus.push(elm);
            });
            adminMenus.subMenu = [];
            aloneMenus.forEach(elm => {
                adminMenus.subMenu.push(elm);
            });
            groupMenus.forEach(elm => {
                adminMenus.subMenu.push(elm);
            });
            // Notice, Image Cloud를 가장 앞으로 End

            if (adminMenus && adminMenus.subMenu) {
                for (let i = 0; i < adminMenus.subMenu.length; i++) {
                    let adminMenu = adminMenus.subMenu[i];
                    // Image cloud 제외, connUrl 이 없으면서 하위 메뉴가 있는 것만 추가
                    if (noticeMenu.indexOf(adminMenu.menuId) > 0 || adminMenu.menuId === 'LEFT_1000000004' 
                               || (adminMenu.connUrl === undefined && adminMenu.subMenu.length > 0)) {
                        let tempSub = this.setMenuObj(adminMenu, adminMenus.subMenu);
                        if (!StringUtil.isNull(tempSub.menuId)) {
                            this.treeObj.push(tempSub);
                        }
                    }
                }
            }
        },
        initLoadSupport() {
            for (const menus of this.menus) {
                if ('Admin' === menus.menuNm) {
                    for (const menu of menus.subMenu) {
                        this.treeObj.push(menu);
                    }
                }
            }
        },
        setMenuObj(menu = {}, menuList, menuObj = []) {
            if (menuList.length === 0) {
                return menuObj;
            }

            let tMenuObj = {
                depth: menu.menuLevel,
                menuId: menu.menuId,
                menuNm: menu.menuNm,
                menuPid: menu.menuPid || '',
                connUrl: menu['connUrl'] || '',
                creationYn: menu['creationYn'] || 'N',
            };

            let sub = menu.subMenu || [];
            if (sub.length > 0) {
                let refSubMenus = [];
                for (let i = 0; i < sub.length; i++) {
                    let tempObj = this.setMenuObj(sub[i], sub.slice(i).concat(sub[i].subMenu || []), menuObj);
                    if (!StringUtil.isNull(tempObj)) refSubMenus.push(tempObj);
                }

                tMenuObj['_children'] = refSubMenus;
            }

            return tMenuObj;
        },
        // 메뉴 이동 이벤트
        handleMoveMenu(event, menu, v) {
            if (!StringUtil.isNull(v)) return;

            let $el = $(event.target).parent('li').parent('ul').parent('li').parent('ul').children('li');
            $el.children('span').removeClass('text-bold');
            $el.children('ul').children('li').children('span').removeClass('text-bold');

            $(event.target).parent('li').parent('ul').children('li').children('span').removeClass('text-bold');
            $(event.target).parent('li').parent('ul').children('li').children('ul').children('li').children('span').removeClass('text-bold');

            $(event.target).addClass('text-bold');
            $(event.target).parent('li').parent('ul').parent('li').children('span').addClass('text-bold');

            store.commit(
                'PARAMS',
                Object.assign(this.params, {
                    menuId: menu.menuId,
                    menuGrpCd: menu.menuGrpCd || '',
                    menuGrpDetailCd: menu.menuGrpDetailCd || '',
                    creationYn: menu.creationYn,
                }),
            );

            // URL 이 없는 경우
            if (StringUtil.isNull(menu['connUrl'])) {
                Vue.$log.warn("▶ AdminSnb.vue handleMoveMenu 'URL' is null");
                return false;
            }

            let connUrl = menu.connUrl.replace('.skp', '');
            Vue.$log.info('▶ AdminSnb.vue handleMove select url : ', connUrl);
            this.$router.push(connUrl);
        },
        // 메뉴 클릭 이벤트
        treeClick(e) {
            if (
                $(e.target)
                    .closest('li')
                    .hasClass('active') == true
            ) {
                $(e.target)
                    .closest('li')
                    .removeClass('active');
            } else {
                $(e.target)
                    .closest('li')
                    .addClass('active');
            }
        },
    },
    // keep-alive activated
    activated() {
        if ('SUPPORT' === this.loginSystem) {
            this.initLoadSupport();
        } else {
            this.initLoad();
        }

        // Vue.$log.info('Refine admin Menus => ', this.loginSystem, this.treeObj);
    },
    // keep-alive deactivated
    deactivated() {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/main/AdminSnb.vue